export const createRequestBody = (values, currentUser, id, userToEdit) => {
    const { domains, domainCode, domainName, domainId } = currentUser.response;
    const domainObject = domains.filter((domain) => domain.code === domainCode);
    let requestObject = {
        active: true,
        admin: true,
        domainCode: values.domains ? values.domains.code || domainCode : domainCode,
        domainId: values.domains ? values.domains.id || domainId : domainId,
        domainName: values.domains ? values.domains.name || domainName : domainName,
        domains: values.domains ? [values.domains] || domainObject : domainObject,
        email: values.email,
        firstName: values.first_name,
        lastName: values.last_name,
        mobileNo: values.phone_number,
        roleId: values.roles && values.roles.id,
        roles: values.roles && [values.roles],
        username: id ? userToEdit.content[0].username : values.email,
    };
    if(values && values.domainCode) {
        requestObject = {
            ...requestObject,
            domainCode: values.domainCode,
            domainName: null,
            domains: [
                {
                "code": values.domainCode,
                }
            ],
            domainName: null,
            domainId: null
        }
        
    }

    if (id && userToEdit && userToEdit.content && userToEdit.content.length) {
        requestObject.id = userToEdit.content[0].id;
    }
    return requestObject;
};

export const createRoleRequest = (values, userToEdit) => {
    return {
        domainCode: userToEdit.domainCode,
        roleId: values.roles.id,
        roleName: values.roles.name,
        username: userToEdit.username,
        appCode: "cardless-admin",
    };
};
